import { CompanyPostJobs } from '../pages/Company/CompanyPostJobs';
import { CompanyManage } from '../pages/Company/CompanyManage';
import { CompanyApplicants } from '../pages/Company/CompanyApplicants';
import { CompanyResume } from '../pages/Company/CompanyResume';
import { ChangePassword } from '../pages/UserDashboard/Settings/ChangePassword';
import { CompanyProfile } from '../pages/CompanyProfile';

/**
 * Rutas protegidas para usuarios tipo EMPRESA
 * Requieren autenticación y tipoPerfil === 'EMPRESA'
 * requiresApproval indica si requiere estado === 'APROBADO'
 */
export const companyRoutes = [
    {
        path: '/company-profile',
        exact: true,
        component: CompanyProfile,
        name: 'Perfil de Empresa',
        description: 'Perfil de la empresa',
        forRole: 'EMPRESA',
        requiresApproval: false // Siempre accesible
    },
    {
        path: '/company-post-jobs',
        exact: true,
        component: CompanyPostJobs,
        name: 'Publicar Vacante',
        description: 'Publicar una nueva vacante',
        forRole: 'EMPRESA',
        requiresApproval: true // Requiere aprobación
    },
    {
        path: '/company-manage-job',
        exact: true,
        component: CompanyManage,
        name: 'Administrar Vacantes',
        description: 'Administrar vacantes publicadas',
        forRole: 'EMPRESA',
        requiresApproval: true // Requiere aprobación
    },
    {
        path: '/company-applicants',
        exact: true,
        component: CompanyApplicants,
        name: 'Ver Postulantes',
        description: 'Ver postulantes por vacante',
        forRole: 'EMPRESA',
        requiresApproval: true // Requiere aprobación
    },
    {
        path: '/company-resume',
        exact: true,
        component: CompanyResume,
        name: 'Postulaciones',
        description: 'Ver postulaciones de candidatos',
        forRole: 'EMPRESA',
        requiresApproval: true // Requiere aprobación
    },
    {
        path: '/company-change-password',
        exact: true,
        component: ChangePassword,
        name: 'Cambiar Contraseña',
        description: 'Cambiar contraseña de la empresa',
        forRole: 'EMPRESA',
        requiresApproval: false // Siempre accesible
    }
];
